export default __webpack_public_path__ + "static/media/NobelWGL-Book.de912590.svg";